import { useDispatch, useReduxState } from 'hooks';
import { breakpoints } from 'styles';
import { SearchForm } from 'components/common';

import type { UpdateEvents } from './EventLog';

interface Props {
  updateEvents: UpdateEvents;
}

const EventLogUserFilter = ({ updateEvents }: Props) => {
  const { messages } = useReduxState();
  const { dispatch } = useDispatch();

  const handleClear = async () => {
    await updateEvents({ page: 1, searchUser: '' });
  };

  const handleError = async (error) => dispatch.handleErrorDispatch(error);

  const handleSearch = async (value) => {
    await updateEvents({ page: 1, searchUser: value });
  };

  return (
    <div className="search-form">
      <SearchForm
        placeholderText={messages.usersSearchUsers}
        onClear={handleClear}
        onError={handleError}
        onSearch={handleSearch}
        size="header"
      />

      <style jsx>{`
        @media (min-width: ${breakpoints.small}px) {
          .search-form :global(input) {
            min-width: 250px;
          }
        }
      `}</style>
    </div>
  );
};

export default EventLogUserFilter;
